import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-user-avatar',
  templateUrl: './user-avatar.component.html',
  styleUrls: ['./user-avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserAvatarComponent {
  private _logoId: string;

  @HostBinding('class')
  private get classes(): string {
    let classes = 'inline-block relative font-main text-base';

    switch (this.size) {
      case 'medium': {
        classes += ' min-w-8 w-8 min-h-8 h-8';
        break;
      }
      case 'small': {
        classes += ' min-w-7 w-7 min-h-7 h-7';
        break;
      }
    }

    return classes;
  }

  @Input()
  firstName: string;

  @Input()
  lastName: string;

  @Input()
  fullName: string;

  @Input()
  email?: string;

  @Input()
  avatarUrl: string;

  @Input()
  deactivated: boolean;

  @Input()
  isMixed = false;

  @Input()
  icon: string;

  @Input()
  size: 'small' | 'medium' | 'containerSize' = 'medium';

  get logoId(): string {
    if (!this._logoId) {
      this._logoId = uuidv4();
    }

    return this._logoId;
  }

  getFullName(): string {
    if (this.fullName) {
      return this.fullName;
    }

    return [this.firstName, this.lastName]
      .filter(Boolean)
      .map((name) => name.trim())
      .join(' ');
  }

  getInitials(): string {
    const fullName = this.getFullName();

    if (fullName) {
      const splitted = fullName.split(' ');
      let result: string;

      if (splitted.length === 2) {
        result = splitted[0].substring(0, 1) + splitted[1].substring(0, 1);
      } else {
        result = splitted[0].substring(0, 1);
      }

      return result.toLocaleUpperCase();
    }

    if (this.email) {
      const username = this.email.split('@')[0];

      return username.substring(0, 2).toLocaleUpperCase();
    }

    return '';
  }
}
